import React, {useEffect, useState} from 'react';
import {List, Spin, Typography} from 'antd';
import {useLazyGetApiWidgetsWaitingJobsQuery} from '../../../api/services/Widgets';
import {useDispatch, useSelector} from 'react-redux';
import {setError} from '../../../features/app/appSlice';
import {RootState} from '../../../app/store';

interface WaitingJobsWidgetProps {
    rowSpan?: number;
    colSpan?: number;
}

const Layout3x3 = ({feedback, meeting}: { feedback: string[]; meeting: string[] }) => (
    <div className="flex justify-around items-center h-full">
        <div className="text-center">
            <div
                className="rounded-full bg-red-500 w-32 h-20 flex items-center flex-col justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">GERİ BİLDİRİM</div>
                {feedback.length}
            </div>
        </div>
        <div className="text-center">
            <div
                className="rounded-full bg-cyan-600 w-32 h-20 flex flex-col items-center justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">1-1 GÖRÜŞME</div>
                {meeting.length}
            </div>
        </div>
    </div>
);

const Layout1x1 = ({feedback, meeting}: { feedback: string[]; meeting: string[] }) => (
    <div className="flex flex-row h-full w-full">
        <div className="flex flex-1 flex-col w-full h-[calc(100%-30px)] items-center">
            <div
                className="rounded-full bg-red-500 w-32 h-20 flex items-center flex-col justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">GERİ BİLDİRİM</div>
                {feedback.length}
            </div>
            <div className="flex flex-col gap-4  mt-2 w-full h-full">
                <List header="GERİ BİLDİRİMLER" dataSource={feedback.slice(0, 2)}
                      renderItem={(item) => <List.Item>{item}</List.Item>}/>
            </div>
        </div>
        <div className="flex flex-1 flex-col w-full h-[calc(100%-30px)] items-center ml-4">
            <div
                className="rounded-full bg-cyan-600 w-32 h-20 flex flex-col items-center justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">1-1 GÖRÜŞME</div>
                {meeting.length}
            </div>
            <div className="flex flex-col gap-4 mt-2 w-full h-full">
                <List header="1-1 GÖRÜŞMELER" dataSource={meeting.slice(0, 2)}
                      renderItem={(item) => <List.Item>{item}</List.Item>}/>
            </div>
        </div>
    </div>

);

const Layout1x2 = ({feedback, meeting}: { feedback: string[]; meeting: string[] }) => (
    <div className="flex flex-col h-full w-full">
        <div className="flex flex-1 flex-col w-full h-full items-center">
            <div
                className="rounded-full bg-red-500 w-32 h-20 flex items-center flex-col justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">GERİ BİLDİRİM</div>
                {feedback.length}
            </div>
            <div className="flex flex-col gap-4  mt-2 w-full">
                <List header="GERİ BİLDİRİMLER" dataSource={feedback.slice(0, 2)}
                      renderItem={(item) => <List.Item>{item}</List.Item>}/>
            </div>
        </div>
        <div className="flex flex-1 flex-col w-full h-full items-center">
            <div
                className="rounded-full bg-cyan-600 w-32 h-20 flex flex-col items-center justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">1-1 GÖRÜŞME</div>
                {meeting.length}
            </div>
            <div className="flex flex-col gap-4 mt-2 w-full">
                <List header="1-1 GÖRÜŞMELER" dataSource={meeting.slice(0, 2)}
                      renderItem={(item) => <List.Item>{item}</List.Item>}/>
            </div>
        </div>
    </div>

);

const Layout2x1 = ({feedback, meeting}: { feedback: string[]; meeting: string[] }) => (
    <div className="flex flex-row h-full w-full">
        <div className="flex flex-1 flex-row w-full h-[calc(100%-30px)] items-center">
            <div
                className="rounded-full bg-red-500 w-32 h-20 flex items-center flex-col justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">GERİ BİLDİRİM</div>
                {feedback.length}
            </div>
            <div className="flex flex-col gap-4  mt-2 w-full">
                <List header="GERİ BİLDİRİMLER" dataSource={feedback.slice(0, 2)}
                      renderItem={(item) => <List.Item>{item}</List.Item>}/>
            </div>
        </div>
        <div className="flex flex-1 flex-row w-full h-[calc(100%-30px)] items-center ml-3">
            <div
                className="rounded-full bg-cyan-600 w-32 h-20 flex flex-col items-center justify-center text-white text-lg font-bold">
                <div className="text-[10px] text-white mt-1">1-1 GÖRÜŞME</div>
                {meeting.length}
            </div>
            <div className="flex flex-col gap-4 mt-2 w-full">
                <List header="1-1 GÖRÜŞMELER" dataSource={meeting.slice(0, 2)}
                      renderItem={(item) => <List.Item>{item}</List.Item>}/>
            </div>
        </div>
    </div>

);


const WaitingJobsWidget: React.FC<WaitingJobsWidgetProps> = ({rowSpan = 1, colSpan = 1}) => {
    const user = useSelector((state: RootState) => state.auth?.user);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [fetchJobs, {data: jobs}] = useLazyGetApiWidgetsWaitingJobsQuery();

    useEffect(() => {
        if (user) fetchJobData();
    }, [user]);

    const fetchJobData = async () => {
        try {
            setIsLoading(true);
            await fetchJobs({userId: user?.id ?? ''}).unwrap();
        } catch {
            dispatch(setError('Veri alınırken hata oluştu.'));
        } finally {
            setIsLoading(false);
        }
    };

    const key = `${rowSpan}x${colSpan}`;
    const feedbackList = (jobs as any)?.feedbackRequests ?? [];
    const meetingList = (jobs as any)?.oneOnOneMeetings ?? [];

    const renderByLayout = () => {
        switch (key) {
            case '1x1':
                return <Layout1x1 feedback={feedbackList} meeting={meetingList}/>;
            case '1x2':
                return <Layout1x2 feedback={feedbackList} meeting={meetingList}/>;
            case '1x3':
                return <Layout1x2 feedback={feedbackList} meeting={meetingList}/>;
            case '2x1':
                return <Layout2x1 feedback={feedbackList} meeting={meetingList}/>;
            case '2x2':
                return <Layout3x3 feedback={feedbackList} meeting={meetingList}/>;
            case '2x3':
                return <Layout3x3 feedback={feedbackList} meeting={meetingList}/>;
            case '3x1':
                return <Layout2x1 feedback={feedbackList} meeting={meetingList}/>;
            case '3x2':
                return <Layout3x3 feedback={feedbackList} meeting={meetingList}/>;
            case '3x3':
                return <Layout3x3 feedback={feedbackList} meeting={meetingList}/>;
            default:
                return <div className="text-gray-400 text-sm italic">Tanımsız yerleşim</div>;
        }
    };

    return (
        <div className="h-full w-full p-4  rounded shadow bg-blue-50">
            <Spin spinning={isLoading}
                  size="large"
                  prefixCls={"widget"}
                  wrapperClassName={"h-full"}
            >
                <p className={"ant-menu-title-content text-center w-full mb-3"}>BEKLEYEN İŞLERİNİZ</p>
                {renderByLayout()}
            </Spin>
        </div>
    );

};

export default WaitingJobsWidget;
